export const getScale = (width, height, aspect) => {
  const scale = width / height
  let radio = null
  if (aspect === '9:16') {
    radio = 9/16
  } else if (aspect === '16:9') {
    radio = 16/9
  } else if (aspect === '1:1') {
    radio = 1
  } else if (aspect === '4:3') {
    radio = 4/3
  } else if (aspect === '3:4') {
    radio = 3/4
  }
  const sh = radio / scale  * 0.5
  return sh
}
